import { resolveElement } from '../../../../common/model/condition/resolveElement'

/*
 * A grid column as it stands on one row. Every row has the same columns, at
 * the same widths, so the grid stays aligned; `conditionals` change only what
 * a cell holds — the entity it searches, its filters, or `editable: false` to
 * grey it out on rows it does not apply to. Read against the row's own data,
 * the same resolver the card fields use.
 */
export const resolveColumn = (column, row) => resolveElement(column, { values: row || {} })

export const isCellEditable = (column, row) => !!resolveColumn(column, row).editable

// The columns a row can be edited in, in order — where Tab and the arrows go.
export const editableColumnsOf = (columns, row) =>
    columns.map((col, i) => isCellEditable(col, row) ? i : -1).filter(i => i !== -1)
